import { makeStyles } from '@mui/styles';
import { Button } from '@mui/material';

/// @Author : Simon Meijer
/// <Summary>
/// ..
/// </Summary>

const useStyles =
    makeStyles({
        root: {
            width: '100%',
            height: '100px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
        },
        resumeButton: {
            position: 'absolute',
            right: '2rem',
            background: 'gray'
        },
        title: {
            fontSize: '1.7em',
            margin: 'auto',
            fontFamily: "Bold",
            textShadow: '0.5px 0.5px 0.5px black',
            textAlign: 'center',
        },
        undertitle: {
            fontSize: '0.5em',
            margin: 'auto',
            fontFamily: "Bold",
            textShadow: '0.5px 0.5px 0.5px black',
        },
        resumeButtonRoot: {
            background: 'black',
            color: 'white'
        }
    });

interface IComponentProperties {
}

export default function Header(p: IComponentProperties) {
    const classy = useStyles();

    return (
        <div className={classy.root}>
            <div className={classy.title}>
                Simon Meijer<br />

                <div className={classy.undertitle}>
                    Creative Developer
                </div>
            </div>
            <div className={classy.resumeButton}>
                <Button color='info' variant="contained" href="/resources/resume.pdf" download>
                    Resume
                </Button>
            </div>
        </div>
    );
}